// APIステータス型（実際のAPIレスポンスの値）
export type APIStatus = 'suggest' | 'apply' | 'decline' | 'archived' | 'matched';

// APIステータスの配列（定数）
export const API_STATUSES: readonly APIStatus[] = [
  'suggest',
  'apply',
  'decline',
  'archived',
  'matched',
] as const;

// API用ステータスラベル
export const API_STATUS_LABELS: Record<APIStatus, string> = {
  suggest: '提案中',
  apply: '応募中',
  decline: '辞退',
  archived: '取り下げ',
  matched: 'マッチ済み',
};

// フィルタリング用のステータス（'all'を含む）
export type APIStatusWithAll = APIStatus | 'all';

// フィルタリング用のステータス配列
export const API_STATUSES_WITH_ALL: readonly APIStatusWithAll[] = ['all', ...API_STATUSES] as const;

// フィルタリング用のステータスラベル（'all'を含む）
export const API_STATUS_LABELS_WITH_ALL: Record<APIStatusWithAll, string> = {
  all: '全て',
  ...API_STATUS_LABELS,
};

import type { AgentApiCandidateEndpointsJobPostEndpointsRecord } from '@/types/serializers';

// UI表示用の拡張型（APIレスポンスを基準に必要なフィールドを追加）
export interface SuggestedCandidate extends Omit<
  AgentApiCandidateEndpointsJobPostEndpointsRecord,
  'candidate_profile'
> {
  // APIレスポンスに含まれないが、UIで必要なフィールド
  candidate_profile_id: number; // candidate_profile.idから抽出
  provided_job_post_id: number; // APIエンドポイントのパラメータから追加
  // candidate_profileは必ず存在する（filterで除外済み）
  candidate_profile: NonNullable<
    AgentApiCandidateEndpointsJobPostEndpointsRecord['candidate_profile']
  >;
}

// 候補者検索のステータス
export const CANDIDATE_SEARCH_STATUS = [
  'processing',
  'rejected',
  'declined',
  'offered',
  'closed',
] as const;

export type CandidateSearchStatus = (typeof CANDIDATE_SEARCH_STATUS)[number];

export const CANDIDATE_SEARCH_STATUS_LABELS: Record<CandidateSearchStatus, string> = {
  processing: '選考中',
  rejected: '不採用',
  declined: '辞退',
  offered: '内定',
  closed: '決定',
};

// 提案フォームデータ
export interface SuggestFormData {
  candidate_profile_ids: number[];
  message?: string;
}
